import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getInterviewList } from '../../service/interview';
import { tags } from './data';
import '../Blog/index.scss';

const Blog: React.FC = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [blogPosts, setBlogPosts] = useState<any[]>([]);

  const categories = useMemo(() => {
    return [
    { value: 'all', label: '全部' },
    ...tags];
  }, [tags]);
  
  const filteredPosts =
    selectedCategory === 'all'
      ? blogPosts
      : blogPosts.filter((post) => post.tag === selectedCategory);
  useEffect(() => {
    getInterviewList({}).then((res) => {
      if (res?.success) {
        setBlogPosts(res.data.list);
      }
    });
  }, []);

  const goToDetail = (postsId: number) => {
    navigate(`/interview-question/article/${postsId}`);
  };

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h1 className="blog-title">技术博客</h1>
        <p className="blog-subtitle">分享前端开发经验和最佳实践</p>
      </div>

      <div className="category-filter">
        {categories.map((category) => (
          <button
            key={category.value}
            className={`filter-btn ${selectedCategory === category.value ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category.value)}
          >
            {category.label}
          </button>
        ))}
      </div>

      <div className="blog-posts">
        {filteredPosts.map((post) => (
          <article
            key={post.postsId}
            className="blog-post"
            onClick={() => goToDetail(post.postsId)}
          >
            <div className="post-meta">
              <span className="post-category">{tags.find((tag) => tag.value === post.tag)?.label || post.tag}</span>
              <span className="post-date">{post.published_at}</span>
              <span className="post-views">👁 {post.view_count}</span>
            </div>
            <h3 className="post-title">{post.title}</h3>
            <p className="post-excerpt">{post.summary}</p>
            <button
              className="read-post-btn"
              onClick={(e) => {
                e.stopPropagation();
                goToDetail(post.postsId);
              }}
            >
              阅读全文
            </button>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Blog;
